import { render, staticRenderFns } from "./InvoiceGateway.vue?vue&type=template&id=3018c32c"
import script from "./InvoiceGateway.vue?vue&type=script&lang=js"
export * from "./InvoiceGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports